import React from 'react';
import { Input, Button } from 'components';
import { Globals, Constants } from 'utils';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { Logo, Crown, Border1 } from 'assets/img';
import { PasswordActive, PasswordInactive } from 'assets/icons';
import { Link } from 'react-router-dom';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Login extends React.Component<Props> {

	state = {
		form: {
			email: '',
			password: ''
		},
		activePassword: false
	}

	componentDidMount() {
		if (this.props.user) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Iniciar Sesión',
				onBack: null
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (!this.state.form.email) {
			Globals.showError("Debe ingresar el correo electrónico");
			return;
		}
		if (!this.state.form.password) {
			Globals.showError("Debe ingresar la contraseña");
			return;
		}
		try {
			const res: any = await AuthService.login(this.state.form);
			await this.props.dispatch({
				type: 'SET_ACCESS_TOKEN',
				payload: res.access_token
			});
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
			if (!res.user?.register_finished) {
				if (res.user?.level_id == Constants.LEVELS.DRIVER) {
	              this.props.history.replace('/driver-finish-register');
	            }
	            else if (res.user?.user_type_id == Constants.USER.USER_TYPE.NATURAL) {
	              this.props.history.replace('/register/natural');
	            }
	            else {
	              this.props.history.replace('/register/business');
	            }
	        }
	        else {
	        	this.props.history.replace('/');
	        }		
		} catch (error: any) {
			Globals.showError(error?.response?.data?.error);
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	render() {
		return (
			<div id="login">
				<div className="wrapper">
					<div className="left">
						<form onSubmit={ this.submit }>
							<div className="container-logo text-center">
								<img src={ Logo } alt="Logo" />
							</div>

							<p className="welcome-1">Inicio de sesión del aliado</p>

							<div className="container-input">
								<Input
									label="Correo"
									placeholder="Escribe tu correo"
									name="email"
									onChange={ this.change }
								/>

								<Input
									label="Clave"
									placeholder="Escribe tu contraseña"
									type={ this.state.activePassword ? 'text' : 'password' }
									name="password"
									onChange={ this.change }
									searchRight
									searchIcon={ this.state.activePassword ? PasswordActive : PasswordInactive }
									onSubmit={ () => this.setState({ activePassword: !this.state.activePassword }) }
								/>

								<Link className="recover" to="/recover">Olvidé mi contraseña</Link>

								<Button type="submit">Iniciar Sesión</Button>
							</div>
						</form>
					</div>
					<div className="right">
						<img className="detail-1" src={ Border1 } alt="Detail 1" />

						<div className="card">
							<img className="icon" src={ Logo } alt="Crown" />
							<p>Regístrate como aliado de Flety</p>
							<Link className="register" to="/register">
								<Button type="submit" color="secondary">Regístrate</Button>
							</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => ({
	user: state.user
}))(Login);